import type { SelectOption } from '@/components/SearchableSelect'
import { foldForSearch } from '@/utils/foldForSearch'

export function packValueToSelectOption(value: string): SelectOption {
  return { id: value, label: value }
}

export function mergePackValueOptions(
  apiValues: { value: string }[],
  currentValue?: string | null
): SelectOption[] {
  const seen = new Set<string>()
  const options: SelectOption[] = []
  for (const row of apiValues) {
    if (seen.has(row.value)) continue
    seen.add(row.value)
    options.push(packValueToSelectOption(row.value))
  }
  const trimmed = currentValue?.trim()
  if (trimmed && !seen.has(trimmed)) {
    options.push(packValueToSelectOption(trimmed))
  }
  return options
}

export function filterPackValuesBySearch<T extends { value: string }>(
  rows: T[],
  searchFilter: string
): T[] {
  const query = foldForSearch(searchFilter)
  if (!query) return rows
  return rows.filter((row) => foldForSearch(row.value).includes(query))
}
